<template>
  <div class="page">
    <div class="Success">
      <div class="top-title">
        <LangRadio :visible-more-lang="visibleMoreLang" />
      </div>
      <!-- 背景红包图容器，独立晃动 -->
      <div v-if="!isHospitalEvaluated" class="redpacket-bg" :style="{ backgroundImage: redpacketBgImage }"></div>
      <!-- 不晃动的内容容器 -->
      <div class="content-wrapper" v-if="!isHospitalEvaluated">
        <div class="content">
          <div class="content-wrap">
            <h2 class="title"><img src="../assets/images/success.png">{{ $t('success.title') }}</h2>
            <p class="des">{{ $t('success.des') }}</p>
          </div>
        </div>
        <!-- 晃动的内容容器 -->
        <div class="shake-content">
          <div v-if="Object.keys(couponInfo).length" class="coupon">
            <span class="price">
              <span class="price_yuan">
                ￥
              </span>
              <span class="price_money">
                {{ couponInfo.conditionFulldisVal }}
              </span>
            </span>
            <span class="redPacket">
              {{ $t('success.coupon.redPacket') }}
            </span>
          </div>
        </div>
      </div>
      <div class="hospital-content" v-if="isHospitalEvaluated">
        <div class="hospital-content-wrap">
          <h2 class="hospital-title"><img src="../assets/images/success.png">{{ $t('success.title') }}</h2>
          <p class="hospital-des">{{ $t('success.des') }}</p>
        </div>
      </div>
      <div v-if="selfUA" class="footer-button">
        <div class="theme-button" @click="back">
          {{ $t('back') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LangRadio from '../components/LangRadio.vue'
import { DateFtt } from '../utils'
import { get as cookieGet } from 'js-cookie';
import JhBridge from 'jh-bridge'
import wx from 'jh-wx-ts'

export default {
  name: 'Success',
  components: { LangRadio },
  data () {
    return {
      couponInfo: {},
      visibleMoreLang: false,
      selfUA: !!cookieGet('selfUA'),
      isHospitalEvaluated: false
    }
  },
  computed: {
    langZh () {
      return this.$i18n.locale === 'zh'
    },
    // 根据当前语言动态计算背景图
    redpacketBgImage () {
      const lang = this.$i18n.locale;
      switch (lang) {
        case 'en':
          return 'url(' + require('../assets/images/en_redpacket.png') + ')';
        case 'ja':
          return 'url(' + require('../assets/images/ja_redpacket.png') + ')';
        case 'ko':
          return 'url(' + require('../assets/images/ko_redpacket.png') + ')';
        default:
          return 'url(' + require('../assets/images/zh_redpacket.png') + ')';
      }
    }
  },
  mounted () {
    const { couponInfo } = this.$route.query
    console.log('couponInfo', couponInfo);

    if (couponInfo) {
      this.couponInfo = JSON.parse(couponInfo)
    }
    // 如果是JiaHuiHealthApp
    if (JhBridge.isJhApp) {
      this.selfUA = true
    }
    if (JhBridge.isMiniProgram) {
      this.selfUA = true
    }
    const { isHospital } = this.$route.query;
    this.isHospitalEvaluated = !!Number(isHospital);
  },
  created () {
    const { moreLang } = this.$route.query;
    this.visibleMoreLang = !!Number(moreLang);
  },
  methods: {
    DateFormat (date) {
      if (date) {
        return DateFtt('yyyy-MM-dd', new Date(date.replace(/-/g, '/')))
      }
    },
    back () {
      if (this.$jsBridge && this.$jsBridge.callHandler) {
        this.$jsBridge.callHandler(
          'callNative',
          JSON.stringify({
            methodName: 'goBackWithResults',
            parameters: {}
          }),
          function responseCallback () {
          }
        );
        return
      }
      if (JhBridge.isJhApp) {
        // 关闭当前页面
        JhBridge.closeWebView()
      }
      if (JhBridge.isMiniProgram) {
        wx.miniProgram.navigateBack();
      }
    }
  }

}
</script>

<style lang="less">
.page {
  background: linear-gradient(321deg, #FFFFFF 0%, #EEFAFF 100%);
  height: 100vh;
}

.top-title {
  padding: 60px 30px 30px;
}

.Success {
  position: relative;
  height: 100vh;

  // 红包背景图，独立晃动
  .redpacket-bg {
    position: absolute;
    top: 155px;
    width: 100%;
    height: 1054px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    animation: shake 0.4s ease-in-out 0.5s 2, shake 0.4s ease-in-out 2.9s 2;
    z-index: 1;
  }

  // 内容容器，不晃动
  .content-wrapper {
    position: relative;
    z-index: 2;
  }

  @keyframes shake {
    0% {
      transform: rotate(0deg);
    }

    50% {
      transform: rotate(-3deg);
    }

    100% {
      transform: rotate(0deg);
    }
  }

  .content-wrap {
    margin: 69px auto 0;
    width: 650px;
    height: 280px;
    background: rgba(255, 255, 255, 0.69);
    box-shadow: inset 0px 10px 30px 0px rgba(226, 240, 255, 0.61), inset 0px -10px 30px 0px rgba(226, 240, 255, 0.6);
    border-radius: 20px 20px 24px 20px;
    border: 6px solid #FFFFFF;
    text-align: center;

    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 48px;
    }

    h2 {
      font-weight: 500;
      font-size: 30px;
      color: #36444E;
      margin-bottom: 30px;

      img {
        width: 50px;
        height: 50px;
        margin-right: 20px;
      }
    }

    p {
      font-weight: 400;
      font-size: 28px;
      color: #36444E;
      padding: 0 71px;
    }
  }

  .hospital-content-wrap {
    margin: 244px auto 0;
    width: 650px;
    background: rgba(255, 255, 255, 0.69);
    box-shadow: inset 0px 10px 30px 0px rgba(226, 240, 255, 0.61), inset 0px -10px 30px 0px rgba(226, 240, 255, 0.6);
    border-radius: 20px 20px 24px 20px;
    border: 6px solid #FFFFFF;
    text-align: center;
    padding-bottom: 100px;

    .hospital-title {
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #36444E;
      padding-top: 110px;
      font-size: 42px;
      margin-bottom: 51px;
    }

    h2 {
      img {
        width: 80px;
        height: 80px;
        margin-right: 24px;
      }
    }

    p {
      font-weight: 400;
      font-size: 30px;
      color: #36444E;
      padding: 0 68px 0 69px;
    }
  }

  .coupon {
    position: relative;
    top: 225px;
    left: 50%;
    transform: translateX(-50%) rotate(-15deg);
    animation: shakecoupon 0.4s ease-in-out 0.5s 2, shakecoupon 0.4s ease-in-out 2.9s 2;
    text-align: center;
    z-index: 3;

    .price_yuan {
      font-weight: 500;
      font-size: 60px;
      color: #F05B5B;
      white-space: nowrap;
    }

    .price_money {
      font-weight: bold;
      font-size: 110px;
      color: #F05B5B;
    }

    .redPacket {
      position: absolute;
      white-space: nowrap;
      top: 20px;
      margin-left: 10px;
      background: #FFFAEF;
      border-radius: 16px 20px 20px 0px;
      border: 2px solid #F6A29D;
      font-weight: 500;
      font-size: 26px;
      color: #F05B5B;
      padding: 0 13px;
    }
  }

  @keyframes shakecoupon {

    0%,
    100% {
      transform: translateX(-50%) rotate(-15deg);
    }

    /* 保留初始旋转 */
    50% {
      transform: translateX(-50%) rotate(-18deg);
    }
  }
}

.footer-button {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  padding: 14px 30px calc(49px + env(safe-area-inset-bottom));
  z-index: 3;

  .theme-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 690px;
    height: 90px;
    background: linear-gradient(135deg, #7BECD3 0%, #45D4A8 100%);
    border-radius: 45px;
    font-weight: 500;
    color: #FFFFFF;
    font-size: 32px;
  }
}
</style>
